import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { bufferToBase64 } from 'src/shared/utilities/utility-functions';
import { RailroadDetailPartialState } from '../../+state/railroad-detail.reducer';
import * as RailroadLogoActions from './railroad-logo.actions';

@Injectable({
	providedIn: 'root',
})
export class RailroadLogoUploadService extends FileReader {
	constructor(private readonly store: Store<RailroadDetailPartialState>) {
		super();
	}

	onload = () => {
		const logo = bufferToBase64(this.result as ArrayBuffer);
		this.store.dispatch(
			RailroadLogoActions.logoSuccessfullyBuffered({ logo })
		);
	};
}
